import styled from "styled-components";

export const GradientButton = styled.button.withConfig({
    shouldForwardProp: (prop) => !['color1', 'color2', 'color3', 'width', 'height'].includes(prop),
})<{color1: string, color2: string, color3: string, width?: number, height?: number}>`
    color: #FFFFFF;
    font-size: 14px;
    font-weight: 700;

    width: ${(props) => props.width ? props.width + 'px' : '100%'};
    height: ${(props) => props.height || 44}px;
    border-radius: 6px;
    border: 1px solid ${({ theme }) => theme.color.point_y_100};
    background-color: ${({ theme }) => theme.color.point_y_100};
    box-shadow: none;
    transition: background-color 0.16s ease, border-color 0.16s ease, color 0.16s ease;

    &:hover {
        filter: brightness(0.96);
        cursor: pointer;
    }

    &:active {
        filter: brightness(0.9);
    }
`;

/** Console controls; GradientButton remains unchanged for the login screen. */
export const Button = styled.button<{ $variant?: 'primary' | 'secondary' | 'ghost' | 'danger'; $size?: 'sm' | 'md' }>`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    flex-shrink: 0;
    height: ${({ $size }) => $size === 'sm' ? 28 : 36}px;
    padding: 0 ${({ $size }) => $size === 'sm' ? 9 : 13}px;
    border-radius: 6px;
    border: 1px solid ${({ theme, $variant = 'primary' }) => $variant === 'ghost' ? 'transparent' : $variant === 'secondary' ? theme.color.primary_400 : $variant === 'danger' ? theme.color.point_n_100 : theme.color.point_y_100};
    background: ${({ theme, $variant = 'primary' }) => $variant === 'primary' ? theme.color.point_y_100 : $variant === 'danger' ? theme.color.point_n_100 : 'transparent'};
    color: ${({ theme, $variant = 'primary' }) => ['primary', 'danger'].includes($variant) ? (theme.name === 'dark' ? '#101828' : '#FFFFFF') : theme.color.text_color_200};
    font: inherit;
    font-size: 13px;
    font-weight: 500;
    white-space: nowrap;
    cursor: pointer;
    transition: background-color 140ms, border-color 140ms;
    &:hover:not(:disabled) {
        background: ${({ theme, $variant = 'primary' }) => $variant === 'primary' ? theme.color.point_y_200 : $variant === 'danger' ? theme.color.point_n_200 : theme.color.primary_50};
    }
    &:focus-visible { outline: 2px solid ${({ theme }) => theme.color.point_y_100}; outline-offset: 2px; }
    &:disabled { opacity: 0.5; cursor: not-allowed; }
    svg { width: 16px; height: 16px; flex-shrink: 0; }
`;
